const CONSENT_TIMEOUT_MS = 1000;

export function ensureConsentResolved() {
  return new Promise(resolve => {
    let resolved = false;
    let timer;

    const safeResolve = reason => {
      if (resolved) {
        return;
      }
      resolved = true;
      clearTimeout(timer);
      resolve({ consentResolved: reason !== 'timeout_fallback', reason });
    };

    timer = setTimeout(() => safeResolve('timeout_fallback'), CONSENT_TIMEOUT_MS);

    if (typeof window === 'undefined') {
      safeResolve('ssr');
      return;
    }

    // eslint-disable-next-line no-underscore-dangle
    if (typeof window.__tcfapi === 'function') {
      // eslint-disable-next-line no-underscore-dangle
      window.__tcfapi('addEventListener', 2, (tcData, success) => {
        if (success && (tcData.eventStatus === 'tcloaded' || tcData.eventStatus === 'useractioncomplete')) {
          // eslint-disable-next-line no-underscore-dangle
          window.__tcfapi('removeEventListener', 2, () => {}, tcData.listenerId);
          safeResolve('tcf_resolved');
        }
      });
      return;
    }

    // eslint-disable-next-line no-underscore-dangle
    if (typeof window.__uspapi === 'function') {
      // eslint-disable-next-line no-underscore-dangle
      window.__uspapi('getUSPData', 1, () => safeResolve('usp_resolved'));
      return;
    }

    safeResolve('no_cmp_detected');
  });
}
